import { useState } from "react";

export const useSchemasFormState = () => {
  const [formData, setFormData] = useState({
    name: "",
    gProductId: null, // { label, value }
    apiCategoryId: null, // { label, value }
    schemaTypeId: null, // { label, value }
    version: "",
    jsonSchema: "", // string (editor)
    effectiveFrom: "",
    effectiveTo: "",
    compatibilityModeId: null, // { label, value }
    isActive: true,

    nameStatus: "unchecked",
    gProductIdStatus: "unchecked",
    apiCategoryIdStatus: "unchecked",
    schemaTypeIdStatus: "unchecked",
    versionStatus: "unchecked",
    jsonSchemaStatus: "unchecked",
    effectiveFromStatus: "unchecked",
    effectiveToStatus: "unchecked",
    compatibilityModeIdStatus: "unchecked",
  });

  const handleChange = (event, selectEvent) => {
    let formState = { ...formData };

    /* =======================
       SELECT HANDLING
    ======================== */
    if (event?.target === undefined && selectEvent) {
      const option = event; // { label, value }

      formState[selectEvent.name] = option;
      formState[selectEvent.name + "Status"] =
        option && option.value ? "success" : "unchecked";

      setFormData(formState);
      return;
    }

    /* =======================
       INPUT HANDLING
    ======================== */
    if (event && event.target) {
      const { name, value, type, checked } = event.target;

      switch (name) {
        case "name": {
          const regex = /^.{1,60}$/;
          formState.nameStatus = regex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }

        case "version": {
          const regex = /^.{1,10}$/;
          formState.versionStatus = regex.test(value.trim())
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }

        case "jsonSchema": {
          if (!value.trim()) {
            formState.jsonSchemaStatus = "unchecked";
          } else {
            try {
              JSON.parse(value);
              formState.jsonSchemaStatus = "success";
            } catch {
              formState.jsonSchemaStatus = "error";
            }
          }
          break;
        }

        case "effectiveFrom":
        case "effectiveTo": {
          formState[name + "Status"] = value ? "success" : "unchecked";
          break;
        }

        default: {
          formState[name + "Status"] = value ? "success" : "unchecked";
        }
      }

      formState[name] = type === "checkbox" ? checked : value;
      setFormData(formState);
    }
  };

  const checkAllFields = () => {
    return (
      formData.nameStatus === "success" &&
      formData.gProductIdStatus === "success" &&
      formData.apiCategoryIdStatus === "success" &&
      formData.schemaTypeIdStatus === "success" &&
      formData.versionStatus === "success" &&
      formData.jsonSchemaStatus === "success" &&
      formData.effectiveFromStatus === "success" &&
      formData.effectiveToStatus === "success"
    );
  };

  return {
    formData,
    setFormData,
    handleChange,
    checkAllFields,
  };
};
